<template>
  <b-container fluid>
    <h4 class="mb-4">
      <strong>Enviar Notificação de contrato </strong>
    </h4>

      <template v-if="loading">
      <a-skeleton active />
    </template>

    <template v-else>
     <a-form  @submit="onSubmit">
       
         <div class="row">
      
          <div class="col-xl" >
            <a-form-item label="Estabelecimento:" label-for="idMerchant">
              <v-select
                label="name"
                :filterable="false"
                :options="merchants"
                :reduce="merchant => merchant.id"
                v-model="form.idMerchant"
                @search="onSearch"
              >
                <template slot="no-options">Pesquisar Estabelecimento</template>
                <template slot="option" slot-scope="option">{{
                  option.name
                }}</template>
                <template slot="selected-option" slot-scope="option">{{
                  option.name
                }}</template>
              </v-select>
            </a-form-item>
          </div>
     
      </div>
        <div class="row">
        
       

          <div class="col-xl">
            <a-form-item label="Modelo:">
              <a-select
                :default-value="form.idDeviceModel"
                v-model="form.idDeviceModel"
              >
                <a-select-option value="null">
                  Selecione
                </a-select-option>
                <a-select-option
                  :value="item.idDeviceModel"
                  v-for="(item, index) in modelos"
                  :key="`${index}`"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-xl">
            <a-form-item label="Categoria:">
              <a-select default-value="null" v-model="form.idDeviceCategory">
                <a-select-option value="null">
                  Selecione
                </a-select-option>
                <a-select-option
                  :value="item.idDeviceCategory"
                  v-for="(item, index) in categorias"
                  :key="`${index}`"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-xl" v-if="form.idDevice > 0">
            <a-form-item label="Status:">
              <a-select default-value="0" v-model="form.idDeviceStatus">
                <a-select-option value="null">
                  Selecione
                </a-select-option>
                <a-select-option
                  :value="item.idDeviceStatus"
                  v-for="(item, index) in statusDispositivos"
                  :key="`statusDispositivo-${index}`"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-xl">
            <a-form-item label="Nota Fiscal:">
              <a-input
                placeholder="# da nota fiscal"
                v-model="form.invoiceNumber"
              />
            </a-form-item>
          </div>

          <div class="col-xl" v-if="showCostCenter">
            <a-form-item label="Centro de Custo:">
              <a-select default-value="null" v-model="form.idCostCenter">
                <a-select-option value="null">
                  Selecione
                </a-select-option>
                <a-select-option
                  :value="item.idCostCenter"
                  v-for="(item, index) in costCenters"
                  :key="`costcenter-${index}`"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="d-flex justify-content-end col-12">
            <b-button
              class="col-md-2 ml-3 mt-2"
              variant="outline-primary"
              @click="cancelar()"
            >
              Voltar
            </b-button>
            <b-btn
              type="submit"
              class="col-md-2 ml-3 mt-2"
              variant="outline-primary"
              :disabled="loading"
            >
              Salvar
              <b-spinner
                small
                variant="primary"
                label="Spinning"
                v-show="loading"
              ></b-spinner>
            </b-btn>
          </div>
        </div>
      </a-form>
    </template>
  </b-container>
</template>

<script>


import { get as _get, debounce as _debounce } from "lodash";
export default {
  components: {
    
  },
  data() {
    return {
      loading: false,
     
      form : {
          idMerchant  : 0 ,
          idMessagerType : 0,
          messageTemplate: '' 
      },
    };
  },
  created() {
 
  },

  methods: {

        onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    search: _debounce((loading, search, vm) => {
      vm.$api
        .get("v1/merchant/keyvalue", {
          params: {
            name: search
          }
        })
        .then(result => {
          loading(false);
          vm.merchants = result.data.payload.map(item => ({
            id: item.id,
            name: item.description
          }));
        })
        .catch(e => {
          // Surpress
        });
    }, 350),
  
 
  }
};
</script>
